import React from 'react'
import { connect } from 'react-redux'
import { Form, Formik } from 'formik'

import { CerealesSelect } from '../operacionesEnSilo/operacionesMovimientos/cerealesSelect/CerealesSelect'
import { CerealesVariedadesSelect } from '../operacionesEnSilo/operacionesMovimientos/cerealesVariedadesSelect/CerealesVariedadesSelect'
import { FILTRADO_SCHEMA } from '../operacionesEnSilo/operacionesMovimientos/constants'
import { IconButton, Button, Grid, Tooltip } from '@material-ui/core'
import Badge from 'react-bootstrap/Badge'
import { Card, Row } from 'react-bootstrap'
import ListAltTwoToneIcon from '@material-ui/icons/ListAltTwoTone'
import FilterListIcon from '@material-ui/icons/FilterList'
import ReplayIcon from '@material-ui/icons/Replay'
import moment from 'moment'
import 'moment/locale/es'

const InfoSilosView = (props) => {
  const {
    siloSeleccionado,
    loading,
    mostrarDetallesSilo,
    aceptar,
    reset,
    filtrado,
    cerealFiltrado,
    variedadFiltrado
  } = props

  const estado = {
    L: {
      nombre: 'LLENO'
    },
    U: {
      nombre: 'EN USO'
    },
    V: {
      nombre: 'VACIO'
    },
    D: {
      nombre: 'DESHABILITADO'
    }
  }

  return (
    (!loading) && <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
      <Formik
        initialValues={{
          cereal: '',
          variedad: '',
          etiqueta: '',
          color: ''
        }}
        enableReinitialize
        validationSchema={FILTRADO_SCHEMA}
        onSubmit={aceptar}
      >
        {({ isSubmitting, isValid, resetForm }) => (<Form>
          <Card className='shadow bg-white rounded' style={{ width: '15rem' }}
            onContextMenu={e => e.preventDefault()}>
            <Card.Body >
              <Card.Title style={{ textAlign: 'center', justifyContent: 'center', fontSize: '1em' }}><strong>Filtros</strong></Card.Title>
              <Row className='d-flex justify-content-start'>
                <Grid container item spacing={2} justify='flex-end'>
                  <Grid container spacing={2} item>
                    <Grid item xs={12} sm={12}>
                      <CerealesSelect />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <CerealesVariedadesSelect />
                    </Grid>
                  </Grid>
                  <Grid item xs='auto'>
                    <Button
                      color='primary'
                      variant='contained'
                      size='small'
                      startIcon={<FilterListIcon />}
                      disabled={isSubmitting || !isValid}
                      type='submit'>
                      Filtrar
                    </Button>
                  </Grid>
                  <Grid item xs='auto'>
                    <Button
                      color='primary'
                      variant='contained'
                      size='small'
                      startIcon={<ReplayIcon />}
                      onClick={() => {
                        resetForm()
                        reset()
                      }}>
                      Restablecer
                    </Button>
                  </Grid>
                </Grid>
              </Row>
              <br />
              <Row className='d-flex align-items-end justify-content-center'>
                {(filtrado) && <h6><Badge variant='secondary'>{cerealFiltrado}</Badge> <Badge variant='secondary'>{variedadFiltrado}</Badge></h6>}
              </Row>
            </Card.Body>
          </Card>
        </Form>)}
      </Formik>
      <br />
      {(siloSeleccionado) &&
        <Card className='shadow bg-white rounded' style={{ width: '15rem' }}
          onContextMenu={e => e.preventDefault()}
          onClick={() => mostrarDetallesSilo(siloSeleccionado)}>
          <Card.Header style={{ backgroundColor: (siloSeleccionado.color) ? `#${siloSeleccionado.color}` : 'white', fontSize: '1.5em' }}></Card.Header>
          <Card.Body>
            <Card.Title style={{ fontSize: '1.5em' }}><strong>{siloSeleccionado.nombre}</strong></Card.Title>
            <Card.Subtitle className='mb-2 text-muted' style={{ fontSize: '1em' }}><strong>{siloSeleccionado.nombreCorto}</strong></Card.Subtitle>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.estado && <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Estado: <strong>{estado[siloSeleccionado.estado].nombre}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.cereal && <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Cereal: <strong>{siloSeleccionado.cereal}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.cerealVariedad && <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Variedad: <strong>{siloSeleccionado.cerealVariedad}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.etiqueta && <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Etiqueta/Condición:</Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.etiqueta && <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}><strong>{siloSeleccionado.etiqueta}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.fechaDeInicioLlenado &&
                <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Inicio de llenado: <strong>{siloSeleccionado.fechaDeInicioLlenado}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.fechaDeFinLlenado &&
                <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Fin de llenado: <strong>{siloSeleccionado.fechaDeFinLlenado}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.fechaUltimoCubicaje &&
                <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Cubicaje: <strong>{moment(siloSeleccionado.fechaUltimoCubicaje).format('DD-MM-YYYY HH:mm')}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {siloSeleccionado.fechaUltimoFumigado &&
                <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Fumigado: <strong>{moment(siloSeleccionado.fechaUltimoFumigado).format('DD-MM-YYYY HH:mm')}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {<Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Vejez: <strong>{siloSeleccionado.vejezSilo}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {(siloSeleccionado.metrosDeVacio && siloSeleccionado.metrosDeVacio > 0) &&
                <Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Vacio: <strong>{siloSeleccionado.metrosDeVacio} mts.</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {<Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Espacio en camiones: <strong>{siloSeleccionado.espacioEnCamiones}</strong></Card.Text>}
            </Row>
            <Row className='d-flex justify-content-start'>
              {<Card.Text style={{ fontSize: '1em', paddingLeft: '2%' }}>Espacio en Tns: <strong>{siloSeleccionado.espacioEnTns} Tns.</strong></Card.Text>}
            </Row>
            <Row className='d-flex align-items-center justify-content-center'>
              <Tooltip title={'Operaciones disponibles'}>
                <span>
                  <IconButton
                    onClick={() => mostrarDetallesSilo(siloSeleccionado)}
                    disabled={false}
                    sx={{ p: 0 }}>
                    <ListAltTwoToneIcon fontSize={'large'} color='primary' />
                  </IconButton>
                </span>
              </Tooltip>
            </Row>
            <Row className='d-flex justify-content-center'>
              <Card.Text
                className='text-muted'
                style={{ fontSize: '0.8em', textAlign: 'center' }}>
                  Operaciones disponibles
              </Card.Text>
            </Row>
          </Card.Body>
          <Card.Footer
            className='text-muted'
            style={{ backgroundColor: (siloSeleccionado.color) ? `#${siloSeleccionado.color}` : 'white', fontSize: '0.8em', textAlign: 'center' }}>
          </Card.Footer>
        </Card>
      }
    </Grid>
  )
}

const mapStateToProps = (state) => ({
  loading: state.movimientos.estadoSilos.loading,
  siloSeleccionado: state.movimientos.estadoSilos.siloSeleccionado,
  filtrado: state.movimientos.estadoSilos.filtrado,
  cerealFiltrado: state.movimientos.estadoSilos.cereal,
  variedadFiltrado: state.movimientos.estadoSilos.variedad
})

export default connect(mapStateToProps, null)(InfoSilosView)
